<template>
    <div class="item">
        <label class="check_wrap">
            <input type="checkbox" v-model="program.isSelected">
            <span class="checkmark"></span>
            <span class="txt ellipsis" style="max-width: 290px;">{{ title }}</span>
        </label>
        <label class="switch_wrap">
            <input :disabled="program.isSelected==false" type="checkbox" v-model="program.isAppSelected">
            <span class="slider round"></span>
        </label>
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
export default {
    props: {
        model: Object,
    },
    data() {
        return {
            program: {}
        }
    },
    watch: {
        model: {
            immediate: true,
            deep: true,
            handler: function(newValue) {
                if (newValue == undefined) { this.program = {} }
                else {
                    this.program = deepCopy(this.model)
                }
            }
        },
        'program.isSelected': {
            handler: function(newValue, oldValue) {
                if (newValue == oldValue) { return }
                if (newValue == false) { this.program.isAppSelected = false }
                this.updateValue()
            }
        },
        'program.isAppSelected': {
            handler: function(newValue, oldValue) {
                if (newValue == oldValue) { return }
                this.updateValue()
            }
        }
    },
    computed: {
        title: function() {
            return this.program.title ?? '-'
        }
    },
    methods: {
        updateValue() {
            this.$emit('input', this.program)
        }
    }
}
</script>

.